import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import DEVICES from '../../common/styles/devices';

export const Container = styled.div`
  border: 1px solid ${COLORS.brandPrimary};
  padding: 16px;
  display: flex;
  border-radius: 10px;
  background-color: ${COLORS.lightPink};
  cursor: pointer;

  .forward-arrow {
    cursor: pointer;
    width: 24px;
    height: 24px;
  }
  .innerWrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  @media ${DEVICES.laptopS} {
    margin: 24px 0 36px 0;
    max-width: unset;
  }
`;

export const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  .progressBar {
    flex: 1;
    min-width: 288px;
    margin: 0 !important;
    @media ${DEVICES.mobileXL} {
      min-width: 224px;
    }

    @media ${DEVICES.mobileL} {
      min-width: 160px;
    }
    @media ${DEVICES.mobileM} {
      min-width: 100px;
    }
  }
  .ui.progress {
    margin: 0 !important;
    border-radius: 10px !important;
    height: 6.5px;
  }
  .bar {
    height: 6.5px !important;
    border-radius: 10px !important;
    background: ${COLORS.brandPrimary} !important;
  }
  .date {
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 12px;
    line-height: 16px;
    color: ${COLORS.textGrey};
    margin-left: 8px;
  }
`;

export const Heading = styled.div`
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 18px;
  line-height: 26px;
  color: ${COLORS.black};
`;

export const SubHeading = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 16px;
  line-height: 22px;
  color: ${COLORS.textGrey};
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 16px;
  justify-content: space-between;
  min-width: 442px;

  .headingContainer {
    display: flex;
    flex-direction: column;
  }
  @media ${DEVICES.tab} {
    min-width: unset;
  }
`;
